import * as yup from 'yup'

export const emailRegExp =
    // eslint-disable-next-line
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const stepTwoValidationSchema = yup.object().shape({
    minimum_pay_range: yup.string()
        .trim()
        .required("Expect a positive integer")
        .matches(/^\d+$/, "Expect a positive integer")
        .test("is-less-than-des", 'Min rate must be less than des rate', (text, ctx) => {
            if (isNaN(ctx.parent.maximum_pay_range) || ctx.parent.maximum_pay_range === "") return true
            return Number(text) <= Number(ctx.parent.maximum_pay_range)
        }),
    maximum_pay_range: yup
        .string()
        .trim()
        .required("Expect a positive integer")
        .matches(/^\d+$/, "Expect a positive integer")
});

export const stepSixValidationSchema = yup.object().shape({
    linkedin_url: yup.string().trim().url("Invalid LinkedIn URL").required("LinkedIn URL is required"), 
});

export const stepEightValidationSchema = yup.object().shape({
    first_name: yup.string().trim().required("First name is required"),
    last_name: yup.string().trim().required("Last name is required"),
    agree: yup.boolean().oneOf([true], "You must agree to the terms and conditions"),
    email: yup.string().trim().required("Email is required").matches(emailRegExp, "Invalid email format"),
    mobile: yup.string().trim().required("Mobile is required").when('$mobile', {
        is: (value) => value && value.trim() !== '',
        then: (schema) => schema.matches(/^\+[1-9]\d{1,14}$/, "Please enter a valid phone number"),
        otherwise: (schema) => schema
    })
});

export const enquiryValidationSchema = yup.object().shape({
    email: yup.string().trim().required("Email is required").matches(emailRegExp, "Invalid email format"),
    website: yup.string().trim().url("Invalid website url")
});

export const contactUsValidationSchema = yup.object().shape({
    name: yup.string().trim().required("Name is required"),
    email: yup.string().trim().required("Email is required").matches(emailRegExp, "Invalid email format"),
    message: yup.string().trim().required("Message is required"),
});
